import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import { useSelector } from "react-redux";
function AdminDiagnosis() {
  const { toggle } = useSelector((state) => state.admin_panel.User);
  return (
    <>
      <section id="content-wrapper">
        <div class="row">
        </div>
      </section>
    </>
  )
}

export default AdminDiagnosis